import React from 'react';
import { Levels, Spinner } from 'react-activity';


const Splash = ({app, msg}) => {
	const theapp = app;
	return (
		<div className="SplashContainer">
			<div className="SplashMessage">{(msg ? msg : 'loading....')}</div>
			<div className="SplashLoadingBlock">
				<Spinner />
			</div>
			<div className="SplashVersionInfo" >{theapp.current_version}</div>
		</div>
	);
}

export default Splash;